import { render, staticRenderFns } from "./handleAlarm.vue?vue&type=template&id=4800858f&"
import script from "./handleAlarm.vue?vue&type=script&lang=js&"
export * from "./handleAlarm.vue?vue&type=script&lang=js&"
import style0 from "./handleAlarm.vue?vue&type=style&index=0&id=4800858f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports